import React, { useRef, useState, useEffect } from "react";
import styles from "./styles.css";
import H2 from "../../shared/h2/component";
import ReadMore from "../read-more";
import PropTypes from "prop-types";
import useToggle from "../../../hooks/use-toggle";
import scrollToRef from "../../../utils/helpers/scroll-to-element";

const SellUsedCar = ({ genericContent = {}, showFullContent = false }) => {
    const { content, heading } = genericContent;
    const [noDisplay, displayContent] = useToggle(true);
    const [showReadMore, setShowReadMore] = useState(false);
    const MAX_CONTENT_HEIGHT = 315;

    const myRef = useRef(null); // Create ref object
    const contentRef = useRef();

    const displayStyleName = () => {
        if (noDisplay && showReadMore && !showFullContent) {
            return "styles.contentHide";
        }
        return "";
    };

    useEffect(() => {
        if (contentRef.current &&
            contentRef.current.getBoundingClientRect().height > MAX_CONTENT_HEIGHT) {
            setShowReadMore(true);
        }
    }, [content, contentRef]);

    return (
        content && <div styleName={"styles.usedCar"} ref={myRef}>
            <H2 text={<div dangerouslySetInnerHTML={{ __html: heading }} />} />
            <div styleName={"styles.details"}>
                <div
                    ref={contentRef}
                    styleName={displayStyleName()}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
            { showReadMore && !showFullContent && <div styleName={"styles.readMore"}><ReadMore
                onButtonClick={() => {
                    if (!noDisplay) {
                        scrollToRef(myRef);
                    }
                    displayContent();
                }}
                text={noDisplay ? "Read More" : "Read Less"}
                caretStyle={noDisplay ? "styles.down" : "styles.up"}
            /></div> }
        </div>

    );
};

SellUsedCar.propTypes = {
    genericContent: PropTypes.object.isRequired,
    showFullContent: PropTypes.bool
};

export default SellUsedCar;
